import { useState, useEffect } from "react";
import { getAxiosInstance } from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Button, Divider, FormControl, FormLabel, IconButton, Input, Spacer, Text } from "@chakra-ui/react";
import Modal from "../Modal";
import DeleteModal from "../DeleteModal";
import { Select } from "chakra-react-select";
import { PLACE_OF_BUSSINESS_TYPE } from "../../utils/types.global";
import { TbTrash } from "react-icons/tb";
import { getPlaceOfBusinessIconByType } from "../../utils/invetory";

interface NewRoleModalProps {
    isOpen: boolean;
    onClose: () => void;
    data: any;
}

const EditModalCompanies = (props: NewRoleModalProps) => {
    const [company, setCompany] = useState<any>({});
    const { t } = useTranslation("translations");
    const [businessInput, setBusinessInput] = useState<any[]>([])
    const [deletedBusiness, setDeletedBusiness] = useState<any[]>([]);
    const [deleteCompany, setDeleteCompany] = useState<boolean>(false);

    const setUpCompanyObject = (value: string, name: string) => {
        setCompany({ ...company, [name]: value, type: 0 });
    }

    const EditCompany = async () => {
        try {
            await getAxiosInstance().put('/companies', {
                id: props.data.id,
                ...company,
                createdAt: new Date(company.createdAt),
                updatedAt: new Date(),
                placeOfBusiness: [...businessInput, ...deletedBusiness],
                no: undefined
            });

            toast.success(t("COMPANY_UPDATED_SUCCESFULLY"), { position: toast.POSITION.BOTTOM_RIGHT });
            setCompany({});
            props.onClose();
        } catch (error) {
            toast.error(t("SOMETHING_WENT_ERONG"), { position: toast.POSITION.BOTTOM_RIGHT });
        }
    }

    const deleteCompanyf = async () => {
        try {
            await getAxiosInstance().delete(`/companies/${props.data.id}`);
            toast.success(t("COMPANY_DELETED_SUCCESFULLY"), { position: toast.POSITION.BOTTOM_RIGHT });
            setCompany({});
            props.onClose();
        } catch (error) {
            toast.error(t("SOMETHING_WENT_ERONG"), { position: toast.POSITION.BOTTOM_RIGHT });
        }
    }

    const setUpBusinessArray = (index: number, name: string, value: any) => {
        let arr = [...businessInput];

        switch (name) {
            case "name":
                arr[index]["name"] = value;
                break;
            case "address":
                arr[index]["address"] = value;
                break;
            case "type":
                arr[index]["type"] = value;
                break;
            default:
        }

        setBusinessInput(arr);
    }

    const addBusinessInputs = () => {
        setBusinessInput([...businessInput, { name: "", address: "", type: 0 }])
    }

    useEffect(() => {
        setCompany(props.data)
    }, [props.data])

    const removeBusiness = (index: number) => {
        let arr = [...businessInput];
        arr[index].isDeleted = true;
        let element = arr[index];
        setDeletedBusiness([...deletedBusiness, element]);
        arr.splice(index, 1);
        setBusinessInput(arr);
    }

    useEffect(() => {
        setBusinessInput(company.placeOfBusiness);
    }, [company.placeOfBusiness])

    const deleteEntity = <Button className="mr-2" name={"Delete"} colorScheme={"red"} variant={"outline"} onClick={(e) => setDeleteCompany(true)}>  Delete </Button>;

    return (
        <Modal
            header={t("Edit Company")}
            isOpen={props.isOpen}
            onClose={props.onClose}
            secondaryActionName={t("Save")}
            secondaryActionEnabled={true}
            secondaryAction={() => EditCompany()}
            additionalBtn={deleteEntity}
        >
            <div className="space-y-2">
                <FormControl>
                    <FormLabel fontSize='lg' as="b">{t("Name")}</FormLabel>
                    <Input value={company.name} name='name' onChange={(e) => { setUpCompanyObject(e.target.value, e.target.name) }} placeholder='ex: SC. - SRL' />
                </FormControl>
                <Text className="flex mt-4" fontSize='lg' as="b">  {t("Places of Business")} </Text>
                <Accordion>
                    {
                        businessInput?.map((n: any, index: number) => {
                            return (
                                <AccordionItem key={`accordion_item_${index}`}>
                                    <AccordionButton>
                                        <Button
                                            onClick={() => removeBusiness(index)}
                                            colorScheme="red"
                                            mr="2"
                                        >
                                            <TbTrash />
                                        </Button>
                                        {getPlaceOfBusinessIconByType(n.type)}
                                        {n.name.length > 0 ? n.name : t("NEW_PALCE_OF_BUSINEES")}
                                        <Spacer />
                                        <AccordionIcon />
                                    </AccordionButton>
                                    <AccordionPanel>
                                        <div className={!n.isDeleted ? "block" : "none"} key={index}>
                                            <FormLabel>{t("TYPE")}</FormLabel>
                                            <Select
                                                className="z-99"
                                                name='type'
                                                isRequired
                                                options={
                                                    Object.keys(PLACE_OF_BUSSINESS_TYPE)
                                                        .filter((v) => isNaN(Number(v)))
                                                        .map((x, index) => ({ value: index, label: t(x), color: "yellow" }))
                                                }
                                                value={{ value: n.type, label: t(PLACE_OF_BUSSINESS_TYPE[n.type]), color: "yellow" }}
                                                tagVariant="solid"
                                                placeholder={t("SELECT_A_PALCE_OF_BUSINESS")}
                                                onChange={(e) => setUpBusinessArray(index, 'type', e?.value)}
                                            />
                                            <div className="mt-3 ">
                                                <FormLabel>{t("Name")}</FormLabel>
                                                <Input
                                                    isRequired
                                                    name='name'
                                                    onChange={(e) => { setUpBusinessArray(index, e.target.name, e.target.value) }}
                                                    value={n.name}
                                                    placeholder='ex: Suceava'
                                                />
                                                <FormLabel>{t("Address")}</FormLabel>
                                                <Input
                                                    name='address'
                                                    onChange={(e) => { setUpBusinessArray(index, e.target.name, e.target.value) }}
                                                    value={n.address}
                                                    placeholder='ex: Str. Pincipală Nr. 3'
                                                />
                                            </div>
                                        </div>
                                    </AccordionPanel>
                                </AccordionItem>
                            )
                        })
                    }
                </Accordion>
                <Button className="mt-2" onClick={() => addBusinessInputs()}> {t("Add Place of Business")}</Button>

                <DeleteModal
                    isOpen={deleteCompany}
                    delete={() => { deleteCompanyf() }}
                    onClose={() => setDeleteCompany(false)}
                />
            </div>
        </Modal>
    )
}


export default EditModalCompanies;